export default "__VITE_ASSET__2a9d42f4__"